import { useFlags } from 'launchdarkly-react-client-sdk'

import { isZeusEnvironment } from 'utils/environment'

import { FeatureFlagSet, featureFlagSetSchema } from './featureFlagSet'

const useFeatureFlags = (): FeatureFlagSet => {
  const realFeatureFlags = useFlags<FeatureFlagSet>()

  const parsedFlags = featureFlagSetSchema.parse(realFeatureFlags)

  return {
    ...parsedFlags,
    /**
     * Custom Fields are only available in Zeus environment
     */
    enableCustomFields: parsedFlags.enableCustomFields && isZeusEnvironment(),
  }
}

export default useFeatureFlags
